import Velocity from 'velocity-animate';

export const scroller = function ( offset, opts ) {
  return new Promise( ( resolve ) => {
    const defs = {
      offset,
      duration: 0,
      complete: () => {
        resolve();
      }
    };
    Velocity( document.body, 'scroll', Object.assign( defs, opts ) );
  });
}
